<div class="section-inner-loose" data-test-class="feature-split">
	<div
		[class]="inverse() ? 'md:flex-row-reverse' : 'md:flex-row'"
		class="flex w-full flex-col gap-8 md:items-center md:gap-0 xl:gap-8 2xl:gap-16"
	>
		<div class="flex w-full flex-col gap-4 px-3 md:gap-6 md:p-8">
			<ng-content />
		</div>
		<div
			class="lg:min-h-120 2xl:min-h-140 sm:min-h-100 relative aspect-square w-full sm:aspect-auto md:self-stretch"
		>
			<div
				[class]="
					inverse() ? 'section-bleed-left' : 'section-bleed-right'
				"
			>
				<vp-slider
					[config]="sliderConfig"
					[itemTemplate]="imageTpl"
					[items]="images()"
					[navTemplate]="navTpl"
					class="block h-full"
				/>
				<ng-template #imageTpl let-img>
					<vp-image-slide
						[height]="900"
						[image]="img"
						[width]="1200"
						sizes="auto, (min-width: 768px) 50vw, 100vw"
					/>
				</ng-template>
				<ng-template #navTpl let-nav>
					<vp-slider-nav-button
						[disabled]="!nav.canScrollPrev"
						(pressed)="nav.scrollPrev()"
						direction="prev"
						variant="light"
					/>
					<vp-slider-nav-button
						[disabled]="!nav.canScrollNext"
						(pressed)="nav.scrollNext()"
						direction="next"
						variant="light"
					/>
				</ng-template>
			</div>
		</div>
	</div>
</div>
